/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { boundaryNodeLocationsGetApiV3BoundaryNodeLocations } from "../../funcs/boundaryNodeLocationsGetApiV3BoundaryNodeLocations.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3BoundaryNodeLocationsRequest$inboundSchema
    .optional(),
};

export const tool$boundaryNodeLocationsGetApiV3BoundaryNodeLocations:
  ToolDefinition<typeof args> = {
    name: "boundary-node-locations-get-api-v3-boundary-node-locations",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await boundaryNodeLocationsGetApiV3BoundaryNodeLocations(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
